// extracted by css-extract-rspack-plugin
export default {"tableSelector":"VCGCu","tableSelectorButtonInner":"tIONg"};